import React from "react";
import Modal from "react-bootstrap/Modal";
import Nodata from "../component/common-component/Nodata";

const RejectDetailModal = (props) => {
  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {props?.data?.machinename} Machine Detail
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {props?.data?.reviewreason ? props?.data?.reviewreason : <Nodata />}
      </Modal.Body>
      <Modal.Footer>
        <button className="grey-btn w-auto" type="reset" onClick={props.onHide}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default RejectDetailModal;
